<script>
import AssetableModal from '@wielink-application/asset/vue/assets/AssetableModal.vue'
export default AssetableModal;
</script>